/** Успешное отключение подписки Яндекс Плюс */

export const gaYandexSubscriptionDisconnected = () => {
  if (typeof window !== 'undefined') {
    window.dataLayer.push({
      event: 'GA_event',
      eventCategory: 'Online disconnection success',
      eventAction: 'Мобильная связь_Services',
      eventLabel: 'Яндекс Плюс',
    });
  }
};
